import { AttachmentInfoDto } from "./AttachmentDtos";

export interface MessageThreadDto {
    id: number;
    category: string;
    title: string;
    status: MessageThreadStatus;
    createdAt: Date;
    latestMessageAt: Date;
    messages: MessageDto[];
    interestedPartyId: number;
}

export interface MessageDto {
    id: number;
    content: string;
    messageThreadId: number;
    status: MessageStatus;
    createdAt: Date;
    attachments: AttachmentInfoDto[];
    sender: MessageSender;
}

export interface CreateMessageDto {
    content: string;
    messageThreadId: number;
    status: MessageStatus;
    sender: MessageSender;
}

export interface CreateMessageThreadDto {
    category: string;
    title: string;
    content: string;
    sender: MessageSender;
}

export enum MessageStatus {
    Draft,
    New,
    Read,
}

export enum MessageThreadStatus {
    Open,
    Archived,
}

export enum MessageSender {
    Customer,
    Official,
}



// WEBPACK FOOTER //
// ./src/util/DTOs/MessageDtos.ts